var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import axios from 'axios';
import { identifyHostname, isLocal, identifyApplication } from '@/support/Client';
import { Token } from '@/support/Token';
import ErrorHandler from '@/support/ErrorHandler';
let Absences = class Absences extends Vue {
    // protected downloadUrl = `${identifyHostname()}/v3/statistics`;
    mounted() {
        //
    }
    downloadFileBlob() {
        const API = `${identifyHostname()}`;
        const headers = {
            'Accept': 'application/vnd.openxmlformats-officedocument'
                + '.spreadsheetml.sheet',
            'Content-type': 'application/json',
        };
        if (isLocal()) {
            headers['X-Application'] = identifyApplication();
        }
        if (Token.get()) {
            headers.Authorization = `Bearer ${Token.get()}`;
        }
        const client = axios.create({
            baseURL: API,
            headers,
            responseType: 'blob',
        });
        client
            .get('/v3/statistics')
            .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'statistics.xlsx');
            document.body.appendChild(link);
            link.click();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get breadcrumbs() {
        return [{ name: this.$tc('absence.title', 2), path: '/absences' }];
    }
};
Absences = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], Absences);
export default Absences;
